import {
  Archive20Regular,
  DocumentPdfRegular,
  DocumentRegular,
  DocumentTableRegular,
  DocumentTextRegular,
  GlobeRegular,
  SlideTextRegular,
} from '@/components/Icon'
import { extensionFromName } from '@/components/AiAskBar/attachmentMetaExtension.js'
import styles from './fileArtifactBlock.module.scss'

/**
 * @param {{
 *   fileName?: string,
 *   artifactKind?: import('@/features/documentPreview/documentPreviewTypes.js').ArtifactKind,
 * }} props
 */
export default function FileArtifactTypeIcon({ fileName = '', artifactKind = 'doc' }) {
  if (artifactKind === 'html') {
    return <GlobeRegular className={styles.chipTypeIcon} aria-hidden />
  }
  if (artifactKind === 'spreadsheet') {
    return <DocumentTableRegular className={styles.chipTypeIcon} aria-hidden />
  }

  const ext = extensionFromName(fileName)

  if (ext === 'zip') {
    return <Archive20Regular className={styles.chipTypeIcon} aria-hidden />
  }
  if (ext === 'pdf') {
    return <DocumentPdfRegular className={styles.chipTypeIcon} aria-hidden />
  }
  if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) {
    return <DocumentTableRegular className={styles.chipTypeIcon} aria-hidden />
  }
  if (['ppt', 'pptx', 'odp'].includes(ext)) {
    return <SlideTextRegular className={styles.chipTypeIcon} aria-hidden />
  }
  if (['txt', 'md', 'json', 'xml', 'html', 'css', 'js', 'jsx', 'ts', 'tsx', 'doc', 'docx'].includes(ext)) {
    return <DocumentTextRegular className={styles.chipTypeIcon} aria-hidden />
  }
  return <DocumentRegular className={styles.chipTypeIcon} aria-hidden />
}
